import './Home.css';

function Home({setActiveApp}){
    return(
        <div className='window-container'>

            <div className='window-row'>
                <div className='window-column window-right'>
                    <div>
                        <span className='window-bar'></span>
                        <span className='window-bar'></span>
                        <span className='window-bar'></span>
                    </div>
                </div>

                <div className='window-column window-middle'>
                    <input type='text' value="http://www.aayanaevanson.com" readOnly/>
                </div>

            </div>

            {/* Projects */}
            <div className='projects'>
                <h2>React Projects</h2>
                <button onClick={() => setActiveApp("todo")}>
                    To Do List App
                </button>
            </div>
            
        </div>
    )
}

export default Home;